import { Box, Skeleton, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useDerivedEventView } from '@verantos-dev/app-state-cohort-builder';

import { useDerivedEventsCohortSection } from './hooks/useDerivedEventsCohortSection';
import { CohortBuilderItemViewCard } from '../../../../components/CohortBuilderItemViewCard/CohortBuilderItemViewCard';
import { CohortSection } from '../../../../components/CohortSection/CohortSection';
import { useEmitResearchAssistantUpdate } from '../../../../hooks/common/useResearchAssistantUpdateForStudyPeriodCard';
import { DerivedEventEditCard } from '../../cohort-builder-edit-cards/DerivedEventEditCard/DerivedEventEditCard';

export const DerivedEventsSection = () => {
  const intl = useIntl();
  const theme = useTheme();

  const {
    derivedEvents,
    showDerivedEventEditModal,
    isAddDerivedEventDisabled,
    disabledAddDerivedEventTooltipText,
    onAddDerivedEventClick,
    onEditDerivedEventClick,
    onDeleteDerivedEventClick,
    isLoading,
    viewMode,
  } = useDerivedEventView();
  const { emptyStateProps, headerProps } = useDerivedEventsCohortSection(
    onAddDerivedEventClick,
    isAddDerivedEventDisabled,
    disabledAddDerivedEventTooltipText
  );
  const emitResearchAssistantUpdate = useEmitResearchAssistantUpdate(viewMode);

  if (isLoading) {
    return (
      <CohortSection headerProps={headerProps} emptyStateProps={emptyStateProps}>
        <Skeleton variant="rectangular" height={78} />
        <Skeleton variant="rectangular" height={78} />
      </CohortSection>
    );
  }

  return (
    <>
      <CohortSection headerProps={headerProps} emptyStateProps={emptyStateProps}>
        {derivedEvents && derivedEvents.length > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(6) }}>
            {derivedEvents.map(({ id, name, type, isInUse, inUseItems }) => (
              <CohortBuilderItemViewCard
                key={id}
                id={id}
                isInUse={isInUse}
                viewMode={viewMode}
                inUseCohortBuilderItems={inUseItems}
                fields={[
                  {
                    id: `${id}-name`,
                    label: `${intl.formatMessage({
                      id: 'projects.cohortBuilder.derivedEventsSection.eventItemLabel',
                    })}`,
                    value: name,
                  },
                  {
                    id: `${id}-type`,
                    label: `${intl.formatMessage({
                      id: 'projects.cohortBuilder.derivedEventsSection.typeItemLabel',
                    })}`,
                    value: type || '',
                  },
                ]}
                onEditClick={onEditDerivedEventClick}
                onDeleteClick={onDeleteDerivedEventClick(emitResearchAssistantUpdate)}
              />
            ))}
          </Box>
        )}
      </CohortSection>
      {showDerivedEventEditModal && <DerivedEventEditCard />}
    </>
  );
};
